"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var arrow_back_svg_1 = __importDefault(require("../../../assets/icons/setas/arrow_back.svg"));
var arrow_downward_svg_1 = __importDefault(require("../../../assets/icons/setas/arrow_downward.svg"));
var arrow_drop_down_svg_1 = __importDefault(require("../../../assets/icons/setas/arrow_drop_down.svg"));
var arrow_forward_svg_1 = __importDefault(require("../../../assets/icons/setas/arrow_forward.svg"));
var arrow_insert_svg_1 = __importDefault(require("../../../assets/icons/setas/arrow_insert.svg"));
var arrow_outward_svg_1 = __importDefault(require("../../../assets/icons/setas/arrow_outward.svg"));
var arrow_upward_svg_1 = __importDefault(require("../../../assets/icons/setas/arrow_upward.svg"));
var chevron_left_svg_1 = __importDefault(require("../../../assets/icons/setas/chevron_left.svg"));
var chevron_right_svg_1 = __importDefault(require("../../../assets/icons/setas/chevron_right.svg"));
var expand_less_svg_1 = __importDefault(require("../../../assets/icons/setas/expand_less.svg"));
var expand_more_svg_1 = __importDefault(require("../../../assets/icons/setas/expand_more.svg"));
var keyboard_double_arrow_down_svg_1 = __importDefault(require("../../../assets/icons/setas/keyboard_double_arrow_down.svg"));
var keyboard_double_arrow_left_svg_1 = __importDefault(require("../../../assets/icons/setas/keyboard_double_arrow_left.svg"));
var keyboard_double_arrow_right_svg_1 = __importDefault(require("../../../assets/icons/setas/keyboard_double_arrow_right.svg"));
var keyboard_double_arrow_up_svg_1 = __importDefault(require("../../../assets/icons/setas/keyboard_double_arrow_up.svg"));
var seta_polygona_svg_1 = __importDefault(require("../../../assets/icons/setas/seta_polygona.svg"));
var south_east_svg_1 = __importDefault(require("../../../assets/icons/setas/south_east.svg"));
var south_west_svg_1 = __importDefault(require("../../../assets/icons/setas/south_west.svg"));
var Tip_bottom_svg_1 = __importDefault(require("../../../assets/icons/setas/Tip bottom.svg"));
var Setas = {
    "arrow_back": arrow_back_svg_1.default,
    "arrow_downward": arrow_downward_svg_1.default,
    "arrow_drop_down": arrow_drop_down_svg_1.default,
    "arrow_forward": arrow_forward_svg_1.default,
    "arrow_insert": arrow_insert_svg_1.default,
    "arrow_outward": arrow_outward_svg_1.default,
    "arrow_upward": arrow_upward_svg_1.default,
    "chevron_left": chevron_left_svg_1.default,
    "chevron_right": chevron_right_svg_1.default,
    "expand_less": expand_less_svg_1.default,
    "expand_more": expand_more_svg_1.default,
    "keyboard_double_arrow_down": keyboard_double_arrow_down_svg_1.default,
    "keyboard_double_arrow_left": keyboard_double_arrow_left_svg_1.default,
    "keyboard_double_arrow_right": keyboard_double_arrow_right_svg_1.default,
    "keyboard_double_arrow_up": keyboard_double_arrow_up_svg_1.default,
    "seta_polygona": seta_polygona_svg_1.default,
    "south_east": south_east_svg_1.default,
    "south_west": south_west_svg_1.default,
    "tip_bottom": Tip_bottom_svg_1.default,
};
exports.default = Setas;
